<script>
  import { isDev, debounce, store, phonePrettify, phonePurify, Link } from '$client';
  import fields, { validate } from './fields';
  import { page } from '$app/stores';
  export let attributes = {};
  export let isH1 = false;
  export let data;

  export let hook = (formData, send) => void send(formData);
  const { city } = store;
  const ERR_MESSAGE = {
    header: 'Ошибка',
    description: `Возникла ошибка при отправке данных, попробуйте позже или позвоните нам <a rel="nofollow" href="tel:${phonePurify(
      $city.phone,
    )}">${phonePrettify($city.phone)}</a>.`,
    button: 'Понятно',
  };

  const REPEAT_MESSAGE = {
    header: 'Вы уже отправили данные',
    description: `Вы уже отправляли эту форму, если вы ошиблись при заполнении формы позвоните нам - <a rel="nofollow" href="tel:${phonePurify(
      $city.phone,
    )}">${phonePrettify($city.phone)}</a> или заполните форму снова через 5 минут.`,
    button: 'Понятно',
  };

  const INVALID_MESSAGE = {
    header: 'Заполните все поля',
    description:
      'Заполнены не все поля или данные введены некорректно. Проверьте введенные данные и повторите попытку снова.',
    button: 'Сейчас исправлю',
  };

  let sended = false;
  const send = async (formData, url) => {
    formData.append('website-location:fields.tekst', $page.url.pathname);
    formData.append('website-city:fields.tekst', $city.header);
    formData.append('website-header:fields.tekst', document.getElementsByTagName('h1')[0].innerText);

    // prettier-ignore
    if ($page.params) formData.append('website-keys:fields.tekst', Object.entries($page.params).map(i => i.join(': ')).join(', '));

    if (sended || (!data.url && !url)) return true;
    sended = true;

    let isErr = false;
    try {
      const body = await fetch(url ?? data.url, { method: 'POST', body: formData });
      const parsed = await body.json();
      console.log(parsed);
      if (parsed.status.code === 402) store.alert.set(INVALID_MESSAGE), (isErr = true);
      if (parsed.status.code === 423) store.alert.set(REPEAT_MESSAGE), (isErr = true);
      else if (parsed.status.code !== 200) store.alert.set(INVALID_MESSAGE), (isErr = true);
      else if (!url && data.finish) store.alert.set(data.finish);
    } catch (err) {
      isErr = true;
      console.log(err);
      store.alert.set(ERR_MESSAGE);
    }

    sended = false;
    return isErr;
  };

  const handler = debounce(e => {
    const formData = new FormData(e.target);
    if (!validate(formData, data.fields)) {
      store.alert.set(INVALID_MESSAGE);
      const [attr1, attr2] = ['input-validation', 'form-validation'];
      e.target.setAttribute(attr2, 'error');
      setTimeout(() => e.target.removeAttribute(attr2), 250);
      setTimeout(() => document.querySelectorAll(`*[${attr1}="error"]`).forEach(e => e.removeAttribute(attr1)), 5000);
    } else hook(formData, send);
  }, 250);

  if (isDev() && !data)
    data = {
      header: 'Заказать вывоз',
      description: 'Перезвоним в течение 5-и минут !',
      button: 'Отправить заявку',
      fields: [
        {
          id: 1,
          __component: 'fields.rejting',
          placeholder: 'Поставьте оценку',
          required: true,
          description: null,
          key: 'rating',
        },
        {
          id: 1,
          __component: 'fields.tekst',
          placeholder: 'Ваше имя',
          description: 'Подсказка под полем',
          pattern: '^[а-яА-Я ].{4,100}$',
          type: 'small',
          required: true,
          key: 'name',
        },
        {
          id: 2,
          __component: 'fields.telefon',
          required: true,
          description: null,
          key: 'phone',
        },
        {
          id: 1,
          __component: 'fields.vybor',
          placeholder: 'С подсказками',
          type: 'input',
          description: null,
          required: true,
          key: 'city',
          options: [
            {
              id: 1,
              header: 'Москва',
            },
            {
              id: 2,
              header: 'Санкт-Петербург',
            },
            {
              id: 3,
              header: 'Другой город',
            },
          ],
        },
        {
          id: 1,
          __component: 'fields.vybor',
          placeholder: 'Выбор',
          type: 'select',
          description: null,
          required: true,
          key: 'city',
          options: [
            {
              id: 1,
              header: 'Москва',
            },
            {
              id: 2,
              header: 'Санкт-Петербург',
            },
            {
              id: 3,
              header: 'Другой город',
            },
          ],
        },
        {
          id: 1,
          __component: 'fields.vybor',
          placeholder: 'Множественный выбор',
          type: 'multiselect',
          description: null,
          required: true,
          key: 'city',
          options: [
            {
              id: 1,
              header: 'Москва',
            },
            {
              id: 2,
              header: 'Санкт-Петербург',
            },
            {
              id: 3,
              header: 'Другой город',
            },
          ],
        },
        {
          id: 1,
          __component: 'fields.data',
          required: true,
          type: 'date',
          placeholder: 'Выберите дату',
          description: null,
          key: 'date',
        },
        {
          id: 1,
          __component: 'fields.data',
          required: true,
          type: 'datetime',
          placeholder: 'Выберите дату и время',
          description: null,
          key: 'datetime',
        },
        {
          id: 2,
          __component: 'fields.pochta',
          placeholder: 'Электронная почта',
          description: null,
          required: false,
          key: 'email',
        },
        {
          id: 1,
          __component: 'fields.tekst',
          placeholder: 'Ваше сообщение',
          description: null,
          pattern: '^[а-яА-Я ].{4,100}$',
          type: 'big',
          required: true,
          key: 'name',
        },
        {
          id: 2,
          __component: 'fields.fajly',
          placeholder: 'Прикрепить водительское удостоверение (фото)',
          description: null,
          type: 'single',
          required: true,
          key: 'license',
        },
        {
          id: 2,
          __component: 'fields.fajly',
          placeholder: 'Прикрепить несколько',
          description: null,
          type: 'many',
          required: true,
          key: 'license',
        },
      ],
    };
</script>

<form novalidate {...attributes} on:submit|preventDefault={handler} method="POST">
  {#if isH1}
    <h1 class="h1">{@html data.header}</h1>
  {:else}
    <h2 class="h2">{@html data.header}</h2>
  {/if}
  <slot />
  {#if data.description}
    <p>
      {@html data.description.replaceAll(
        '$$phone',
        `<a style="color:#041bec" href="tel:${phonePurify($city.phone)}">${phonePrettify($city.phone)}</a>`,
      )}
    </p>
  {/if}
  <div>
    {#each data.fields as field, i}
      <div style="z-index:{data.fields.length - i}">
        {#if field.__component in fields}
          <svelte:component
            this={fields[field.__component]}
            data={{ ...field, key: field.key + ':' + field.__component }} />
        {:else}
          <svelte:component
            this={fields['fields.tekst']}
            data={{ ...field, key: field.key + ':' + field.__component }} />
        {/if}
        {#if field.description}
          <p>{@html field.description}</p>
        {/if}
      </div>
    {/each}
  </div>
  <p class="agree">
    Нажимая на кнопку, вы даете согласие на обработку персональных данных и соглашаетесь с <Link href="/politic"
      >политикой конфиденциальности</Link>
  </p>
  <button class="push-button" disabled={sended} type="submit">{data.button}</button>
</form>

<style lang="scss">
  .agree {
    max-width: 450px;
    margin-top: 20px;
    color: rgb(44 51 60 / 100%);
    font-weight: 500;
    font-size: 14px;
    font-family: Roboto;
    font-style: normal;

    @media only screen and (min-width: 767.98px) {
      line-height: 24px;
    }

    :global(a) {
      color: #041bec;
    }
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    div {
      display: flex;
      width: 100%;

      :global(> div > input),
      :global(> div > select),
      :global(> div > label),
      :global(> div > button),
      :global(> div > textarea) {
        display: flex;
        width: 100%;
        min-width: 100%;
        height: 65px;
        min-height: 65px;
        padding: 16px 24px 14px;
        color: #2c333c;
        font-weight: 600;
        font-size: 16px;
        font-family: Vela Sans;
        font-style: normal;
        line-height: 26px;
        background: #fff;
        border: 2px solid rgb(119 129 143 / 45%);
        border-radius: 5px;
        resize: none !important;
      }

      :global(> div > textarea) {
        height: 148px;

        :global(~ span) {
          top: 34px;
        }
      }

      :global(> div > *:not(textarea) ~ span) {
        top: 50%;
      }

      :global(*[data-focus='true'] ~ span) {
        top: -1px;
      }

      :global(*[data-focus='false'] ~ span) {
        width: calc(100% - 28px);
      }

      :global(> div > span) {
        position: absolute;
        left: 24px;
        z-index: 2;
        margin-right: 24px;
        color: rgb(44 51 60 / 100%);
        font-weight: 600;
        font-size: 16px;
        font-family: Vela Sans;
        background: #fff;
        border-radius: 5px;
        transform: translateY(-50%);
        transition: top 0.2s;
        pointer-events: none;
        padding-inline: 5px;
        padding-block: 6px;

        :global(> strong) {
          margin-inline: 2px;
          color: rgb(255 99 71);
        }
      }

      :global(> div > strong) {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 2;
        color: rgb(255 99 71);
      }

      div {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 5px;
        width: 100%;

        p {
          margin-left: 24px;
          color: rgb(102 102 135);
          font-size: 0.8rem;
          font-family: Roboto;
          line-height: 1.33;
        }

        :global(div) {
          position: relative;
          width: 100%;
        }
      }
    }
  }

  button[disabled] {
    opacity: 0.7;
    pointer-events: none;
  }

  :global(form[form-validation='error']) {
    :global(button) {
      animation: horizontal-shaking 0.25s;
      animation-iteration-count: 2;
    }
  }

  :global(*[input-validation='error']) {
    border-color: rgb(255 99 71) !important;
  }

  @keyframes horizontal-shaking {
    0% {
      transform: translateX(0);
    }

    25% {
      transform: translateX(5px);
    }

    50% {
      transform: translateX(-5px);
    }

    75% {
      transform: translateX(5px);
    }

    100% {
      transform: translateX(0);
    }
  }
</style>
